import isNil from 'lodash/isNil'

import { NetworkError } from '../error'

export function hasFetchSucceeded(response: Response): boolean {
  return (
    !isNil(response?.status) && response.status >= 200 && response.status < 300
  )
}

const REQUEST_GENERIC_ERROR = 'Error sending HTTP request'

function handleFailedJsonContent(response) {
  const json = response.data
  const message = json?.detail || REQUEST_GENERIC_ERROR
  let detail = undefined
  if (response.status === 400) {
    detail = json
  }

  const error = new NetworkError({
    message,
    status: response.status,
    detail,
    cause: {
      response,
      responseData: json,
      timestamp: new Date().toISOString(),
    },
  })
  Error.captureStackTrace(error, handleFailedJsonContent)
  throw error
}

function handleFailedRequest(response, contentType) {
  if (contentType && contentType.indexOf('application/json') !== -1) {
    handleFailedJsonContent(response)
  }

  const error = new NetworkError({
    message: REQUEST_GENERIC_ERROR,
    status: response.status,
    cause: {
      response,
      contentType,
      timestamp: new Date().toISOString(),
    },
  })
  Error.captureStackTrace(error, handleFailedRequest)
  throw error
}

async function handleSuccessfulBlob(response) {
  const contentDisposition = response.headers['content-disposition']
  const fileName = contentDisposition.split('filename=')[1] || ''
  const blob = response.data

  return [fileName, blob]
}

export async function validateResponse(response) {
  const contentType = response.headers['content-type']

  if (!hasFetchSucceeded(response)) {
    handleFailedRequest(response, contentType)
  }

  if (['text/csv', 'application/pdf'].includes(contentType)) {
    return await handleSuccessfulBlob(response)
  }

  return response.data
}
